import React, { useState } from "react";
import "./faq.css";
import { Helmet } from "react-helmet";

const faqData = [
  {
    question: "Which car services do you provide?",
    answer:
      "We provide complete auto care services including periodic maintenance, engine repair, brake repair, denting & painting, car detailing, ceramic coating, interior & exterior cleaning, suspension repair and more.",
  },
  {
    question: "Do you provide car service at home in Palwal?",
    answer:
      "Yes, we offer doorstep car service in Palwal for general checkups, oil change, battery replacement and minor repairs.",
  },
  {
    question: "How much time does a periodic car service take?",
    answer:
      "A standard periodic maintenance service usually takes 3–5 hours depending on the car condition and service package.",
  },
  {
    question: "Is your car repair service affordable?",
    answer:
      "Yes, AutoCare Palwal focuses on transparent pricing, genuine spare parts and cost-effective car repair solutions.",
  },
  {
    question: "Do you use genuine spare parts?",
    answer:
      "We only use genuine or OEM-quality spare parts to ensure safety, performance and long vehicle life.",
  },
  {
    question: "Do you provide warranty on repairs?",
    answer:
      "Yes, selected repairs and spare parts come with service warranty depending on the type of work performed.",
  },
  {
    question: "Can I book a car service online?",
    answer:
      "Absolutely. You can book your car service online through our website or contact us directly via call or WhatsApp.",
  },
  {
    question: "Which car brands do you service?",
    answer:
      "We service all major car brands including Maruti, Hyundai, Honda, Tata, Mahindra, Kia, Toyota and more.",
  },
  {
    question: "Do you offer emergency or accidental repair?",
    answer:
      "Yes, we provide accidental car repair, bumper repair, panel replacement and insurance assistance.",
  },
  {
    question: "Why should I choose AutoCare Palwal?",
    answer:
      "We are known as one of the best car repair and auto care service centers in Palwal with experienced mechanics, modern tools and customer-first approach.",
  },
  {
    question: "Do you offer car detailing and ceramic coating?",
    answer:
      "Yes, we provide professional car detailing, 9H ceramic coating, rubbing & polishing, waxing and paint enhancement services.",
  },
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
<Helmet>
  <title>
    Car Repair FAQ – AutoCare Palwal | Common Service Questions
  </title>

  <meta
    name="description"
    content="Find answers to common questions about car repair, servicing, doorstep car service, pricing, warranty and car detailing in Palwal by AutoCare."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/faq"
  />
</Helmet>
<Helmet>
  {/* existing title, meta, canonical */}

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    })}
  </script>
</Helmet>

    <section className="faqSection">
      <div className="faqContainer">
        <h2>Frequently Asked Questions</h2>
        <p className="faqSubtitle">
          Common questions about our auto care and car repair services in Palwal
        </p>

        <div className="faqList">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faqItem ${activeIndex === index ? "active" : ""}`}
            >
              <div
                className="faqQuestion"
                onClick={() => toggleFAQ(index)}
              >
                <span>{item.question}</span>
                <span className="arrow">
                  {activeIndex === index ? "▲" : "▼"}
                </span>
              </div>

              <div className="faqAnswer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
}
